export const HOW_RENT = {
  Header: '¿Qué necesitas para alquilar?',
  Body: [
    {
      Title: 'Identificación:',
      Paragraphs: [
        `Para poder retirar el auto, tanto el conductor principal así como también los conductores adicionales,
        deberán presentar su permiso de conducir vigente a la fecha, con un mínimo de antiguedad de 2 años.`,
        `Los conductores también deberán presentar su documento de identidad en los países del Mercosur. En destinos
        internacionales se deberá presentar los pasaportes de los conductores.`,
        `Recuerda que tu licencia de conducción debe estar vigente;  ya que si este documento se encuentra con la 
        fecha de vencimiento impresa y y sea una fecha ya pasada al momento de tomar el servicio, esta licencia 
        no tienen ninguna validez a nivel internacional ya que será considerado como un documento vencido por 
        las autoridades del país donde se tomará el servicio, con lo cual la empresa de alquiler puede negar la 
        entrega del vehículo, ya que la licencia no es valida.`
      ]
    },
    {
      Title: 'Bloqueo de tarjeta:',
      Paragraphs: [`Como conductor principal debes contar con una tarjeta de crédito física, la cual debe estar a tu nombre y 
                    tener los datos de la tarjeta impresos en ella; recuerda que las rentadoras no aceptan tarjetas de crédito 
                    digitales y que solamente puedes presentar una tarjeta física que corresponda a las franquicias Visa, 
                    American Express, Dinners Club o MasterCard. La rentadora realizará un bloqueo por un monto específico 
                    a modo de garantía, esto puede variar dependiendo de la rentadora y el tipo de auto contratado; el monto 
                    retenido en la tarjeta será liberado al momento de devolver el auto.`
      ],
      Conditions: [
        {
          ExcludedCompanies: ['Localiza'],
          Paragraphs: [`El conductor principal deberá contar con una tarjeta de crédito a su nombre. Dicha tarjeta funciona como
                 garantía y se bloqueará un monto específico, según la rentadora y tipo de auto, que será liberado al
                 devolver el vehículo.`]
        }
      ]
    },
    {
      Title: 'Restricción de edad:',
      Paragraphs: [
        'Si el usuario tiene menos de 25 años, y más de 65 años, la tarifa tendrá un incremento.',
      ]
    }
  ]
};
